import { Dialog, DialogActions } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import ListCategoryPost from './listCategoryPost'
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import DialogConfirm from '../dialog'
import Snackbar from '../snackbar';
import Loading from '../loading';
import {
    Input,
    FormControl,
    FormControlLabel,
    Switch,
    Button,
} from '@material-ui/core';
import { styles } from './style';

function Transition(props) {
    return <Slide direction="down" {...props} />;
}
class ModalCategoryPost extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialogs: this.props.flagOpen || false,
            topLevelCategory: this.props.action === 'edit' ? (this.props.item && this.props.item.parentCode ? false : true) : true,
            categoryName: this.props.action === 'edit' && this.props.item ? this.props.item.name : '',
            itemDelete: {},
        }
        this.handleDialogOpen = this.handleDialogOpen.bind(this)
        this.handleDialogClose = this.handleDialogClose.bind(this)
    }
    componentWillMount() {
        this.props.onRef(null);
    }

    componentDidMount() {
        this.props.onRef(this)
    }
    handleSwitch = (e) => {
        this.setState({
            topLevelCategory: e.target.checked
        })
    }
    handleChangeCategoryName = (value) => {
        this.setState({
            categoryName: value
        })
    }
    handleChangeSearch = async (value) => {
        let { t } = this.props
        if (value) {
            this.loading.startLoading()
            let check = await this.props.getList({ search: value });
            this.loading.stopLoading()
            if (check.code === 1 && !check.data.length) {
                this.mSnackbar.handleClick(t('category_post_no_result_found'))
            }
            else if (check.code !== 1) {
                this.mSnackbar.handleClick(check.message, 'error')
            }
        }
        else this.ListCategoryPost.getListMultiLevel()


        // if(check.code === 1) { 
        //     this.mSnackbar.handleClick('delete success') 
        //     this.ListCategoryPost.getListMultiLevel()
        // }
        // else if(check.code !== 1) {
        //     this.mSnackbar.handleClick(check.message,'error') 
        // }  
    }
    handleDialogClose() {
        this.setState({ openDialogs: false })
    }
    handleDialogOpen() {
        this.setState({ openDialogs: true })
    }
    handleCheckCategory = (item) => { 
    }
    handleDeleteCategory = async () => {
        this.DialogConfirm.handleDialogClose()
        let { t } = this.props
        this.loading.startLoading()
        let check = await this.props.deletePostCategory({ id: this.state.itemDelete.id });
        this.loading.stopLoading()
        if (check.code === 1) {
            this.mSnackbar.handleClick(t('category_post_delete_new_category_successful'))
            this.ListCategoryPost.getListMultiLevel()
        }
        else if (check.code !== 1) {
            this.mSnackbar.handleClick(check.message, 'error')
        }
    }
    handleConfirm = (item) => {
        let _this = this
        this.setState({ itemDelete: item }, function () {
            _this.handleDeleteCategory()
            // _this.DialogConfirm.handleDialogOpen()
        })

    }
    handleEmptyList = () => {
        let { t } = this.props
        this.mSnackbar.handleClick(t('category_post_nothing_category_post'), 'info')
        this.setState({ topLevelCategory: true })
    }
    handleAddNewCategory = async () => {
        let { t } = this.props
        if (!this.state.categoryName) this.mSnackbar.handleClick(t('category_post_name_category_required'))
        else {
            if (!this.state.topLevelCategory && !this.ListCategoryPost.getValue())
                this.mSnackbar.handleClick(t('category_post_select_at_least_one_parent_category'))
            else {
                let parentCategory = '';
                if (!this.state.topLevelCategory) parentCategory = this.ListCategoryPost.getValue()
                this.loading.startLoading()
                let check = await this.props.addPostCategory({ name: this.state.categoryName, parentCode: parentCategory });
                this.loading.stopLoading()
                if (check.code === 1) {
                    this.mSnackbar.handleClick(t('category_post_add_new_category_successful'))
                    if (!this.state.topLevelCategory) this.ListCategoryPost.getListMultiLevel()
                    this.setState({categoryName: ''})
                }
                else if (check.code !== 1) {
                    this.mSnackbar.handleClick(check.message, 'error')
                }
            }
        }
    }
    handleAddEditCategory = async () => {
        let { t } = this.props
        if (!this.state.categoryName) this.mSnackbar.handleClick(t('category_post_name_category_required'))
        else {
            if (!this.state.topLevelCategory && !this.ListCategoryPost.getValue())
                this.mSnackbar.handleClick(t('category_post_select_at_least_one_parent_category'))
            else {
                let parentCategory = '';
                if (!this.state.topLevelCategory) parentCategory = this.ListCategoryPost.getValue()
                this.loading.startLoading()
                let check = await this.props.editPostCategory({ name: this.state.categoryName, parentCode: parentCategory, id: this.props.id });
                this.loading.stopLoading()
                if (check.code === 1) {
                    this.mSnackbar.handleClick(t('category_post_edit_category_successful'))
                    this.ListCategoryPost.getListMultiLevel()
                }
                else if (check.code !== 1) {
                    this.mSnackbar.handleClick(check.message, 'error')
                }
            }
        }
    }
    render() {
        const { classes, t, theme, action } = this.props;
        
        return (
            <>
                <Dialog
                open={this.state.openDialogs}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.props.handleDialogClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                classes={{
                    paperWidthSm: classes.paperWidthSm,
                }}
                style = {{zIndex: 3000}}

            > 
              <Loading onRef={id => (this.loading = id)} />
                <Snackbar
                    color='white'
                    onRef={snackbar => (this.mSnackbar = snackbar)}
                />
                <DialogConfirm
                    onRef={dialog => (this.DialogConfirm = dialog)}
                    disagree={t('category_post_cancel')}
                    agree={t('category_post_yes')}
                    title={t('category_post_confirm')}
                    content={t('category_post_you_want_to_delete_category') + ' ' + this.state.itemDelete.name + ' ?'}
                    action={this.handleDeleteCategory}
                />
                <Typography variant="h4" className={classes.title}>
                    {this.props.action === 'edit' ? t('category_post_edit_category') : t('category_post_add_new_category')}
                </Typography>
                <FormControl className={classes.inputPhoneNumber}>
                    <Input
                        required
                        id="custom-css-standard-input"
                        disableUnderline
                        placeholder={t("category_post_new_category_name")}
                        value={this.state.categoryName}
                        onChange={(event) => this.handleChangeCategoryName(event.target.value)}
                        onKeyPress={this.onKeyPressPhone}
                    />
                </FormControl>
                <div className={classes.topLevelCategoryContainer}>
                    <FormControl>
                        <Switch
                            checked={this.state.topLevelCategory}
                            onChange={this.handleSwitch}
                            value="checkedA"
                            inpsutProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </FormControl>
                    <Typography variant="h4" className={classes.childTitle}>
                        {t('category_post_top_level_category')}
                    </Typography>
                </div>
                {!this.state.topLevelCategory &&
                    <Typography variant="h4" className={classes.parentCategory}>
                        {t('category_post_choose_a_parent_category')}
                    </Typography>}
                {!this.state.topLevelCategory &&
                    <FormControl className={classes.inputSearch}>
                        <div><SearchIcon /></div>
                        <Input
                            required
                            classes={{
                                root: classes.inputRoot,
                            }}
                            id="custom-css-standard-input"
                            disableUnderline
                            placeholder={t("category_post_search") + '...'}
                            value={this.state.valuePhoneNumber}
                            onChange={(event) => this.handleChangeSearch(event.target.value)}
                            onKeyPress={this.onKeyPressPhone}
                        />
                    </FormControl>}
                {!this.state.topLevelCategory &&
                    <ListCategoryPost onRef={id => (this.ListCategoryPost = id)} handleDeleteCategory={this.handleConfirm} handleCheckCategory={this.handleCheckCategory} handleEmptyList={this.handleEmptyList} value={this.props.item ? this.props.item.parentCode : ''} />
                }
                <div className={classes.containerButton}>
                    <Button variant="contained" className={classes.buttonCacel} onClick={() => this.handleDialogClose()}>
                        {t('category_post_cancel')}
                    </Button>
                    {this.props.action === 'edit' ?
                        <Button variant="contained" color="primary" className={classes.button} onClick={() => this.handleAddEditCategory()}>
                            {t('category_post_edit')}
                        </Button>
                        :
                        <Button variant="contained" color="primary" className={classes.button} onClick={() => this.handleAddNewCategory()}>
                            {t('category_post_add')}
                        </Button>
                    }
                </div>
                <DialogActions classes={{ root: classes.rootDialogActions }}>
                    <IconButton aria-label="Close" size="small"
                        className={classes.marginCloseButton}
                        onClick={this.handleDialogClose}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton >
                </DialogActions>
            </Dialog>
            </>
        );
    }
}


ModalCategoryPost.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
const mapState = state => ({
});

const mapDispatch = dispatch => ({
    getList: dispatch.postCategory.getList,
    addPostCategory: dispatch.postCategory.add,
    editPostCategory: dispatch.postCategory.edit,
    deletePostCategory: dispatch.postCategory.delete
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(ModalCategoryPost)));
